import Alert from '@mui/material/Alert';
import { useErrorAlertStyles } from './error-alert.styles';

export function ErrorAlert({ open, message }: { open: boolean; message: string }) {
  const classes = useErrorAlertStyles();
  return open ? (
    <Alert className={classes.alert} severity="error" variant="filled">
      <span className={classes.text}>{message}</span>
    </Alert>
  ) : null;
}
